import React from "react";
import { DialogWindow } from "./DialogWindow";
import { Box, Button, Stack, styled } from "@mui/material";
import { ReactComponent as CongratImage } from "images/congrat.svg";
import { Level, LevelColorSx, NewLevelIcon } from "Dashboard.style";
import {
  NUMBER_OF_LEVELS,
  REFERRALS_IN_LEVEL,
  getUserPosition,
} from "Dashboard";
import { ReactComponent as DiamondImage } from "images/big-diamond.svg";

const Title = styled(Box)``;

const Message = styled(Box)`
  margin-top: 10px;
  max-width: 373px;

  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;

  color: #272727;
`;

const DataHolder = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 22px 0;
  width: 404px;

  border-radius: 8px;
  background-color: #efefef;
`;

const NextGoal = styled(Box)`
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
`;

const Position = styled(Box)`
  font-size: 14px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: -0.37156790494918823px;
  text-align: center;
  color: #225da4;
`;

const DiamondUserPosition = styled(Box)`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.37156790494918823px;
  text-align: center;

  color: #272727;
`;

export const NewLevelDialog = ({
  handleClose,
  level,
  viewRewards,
  progress,
  newCountsForUpdate,
  setNewProgress,
}) => {
  const position = getUserPosition(progress);

  const isDiamond = newCountsForUpdate >= REFERRALS_IN_LEVEL * NUMBER_OF_LEVELS;

  return (
    <DialogWindow
      title={
        isDiamond ? (
          <>
            <DiamondImage />
            <Title>Diamond Unlocked</Title>
          </>
        ) : (
          <>
            <CongratImage sx={{ marginTop: "-10px" }} />
            <Title>Level Unlocked</Title>
          </>
        )
      }
      content={
        <Stack alignItems={"center"} gap={2}>
          <Message>
            Thank you for your referrals! We truly value your partnership. Enjoy
            your upgrade!
          </Message>
          <DataHolder>
            {isDiamond ? (
              <DiamondUserPosition>
                You are now in the top {position}% of Referral Stream users!
              </DiamondUserPosition>
            ) : (
              <>
                {NewLevelIcon[level]}
                <Stack alignItems={"flex-start"}>
                  <Level
                    // @ts-ignore
                    sx={{ color: LevelColorSx[level], margin: 0 }}
                  >
                    {level}
                  </Level>
                  <NextGoal>
                    {REFERRALS_IN_LEVEL} Referrals to next level
                  </NextGoal>
                </Stack>
              </>
            )}
          </DataHolder>
          {!isDiamond && (
            <Position>
              You are now in the top {position}% of Referral Stream users
            </Position>
          )}
        </Stack>
      }
      handleClose={() => {
        setNewProgress(newCountsForUpdate);
        handleClose();
      }}
      withCloseButton
      actions={
        <Stack justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <Button
            variant="contained"
            onClick={() => {
              handleClose();
              setNewProgress(newCountsForUpdate);
            }}
          >
            Got it
          </Button>
        </Stack>
      }
    />
  );
};
